import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 40px 20px;
  text-align: center;
`;

export const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #e8f5e9;
  color: #4caf50;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  svg {
    font-size: 40px;
  }
`;

export const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: var(--black);
  margin-bottom: 8px;
`;

export const SubTitle = styled.p`
  font-size: 16px;
  color: var(--gray);
  max-width: 500px;
  line-height: 1.5;
  margin-bottom: 32px;
`;

export const FormCard = styled.div`
  width: 100%;
  max-width: 400px;
  background-color: var(--white);
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 24px;
  border: 1px solid var(--light-gray);
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const SubmitButton = styled.button`
  background-color: var(--fixit);
  color: var(--white);
  border: none;
  border-radius: 8px;
  padding: 16px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 8px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 6px 20px rgba(152, 53, 209, 0.4);
  }

  &:disabled {
    background-color: var(--gray);
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const BackButton = styled(SubmitButton)`
  background-color: var(--light-gray);
  color: var(--dark-gray);
  margin-top: 8px;

  &:hover {
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.1);
  }
`;